import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Icon,
  Modal,
  Select,
  Radio,
  Row,
  Col,
  Spin,
  Input,
  message,
  Button,
  notification,
  Checkbox,
} from "antd";
import { Translate } from "react-translated";
import F from "../../../Functions"
import moment from "moment";
import { REVIEWSCHEDULER, URLPaths, VONBOARDER } from "../../../utils/Constants";
import { withRouter } from 'react-router-dom';
import { useBoundStore } from "../../../store/useBoundStore";
import { CREATE_CALL_ATTEMPT_HISTORY, NON_RESPONSIVE, NOT_INTERESTED, NOT_REACHED } from "../../../utils/Api_enums";


const { Option } = Select;
const { TextArea } = Input;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


const AppointmentActionModal = (props) => {
  const { showModal, hideModal, title, bfile, user: loggedInUser, action, init, history } = props;
  const [defaultSelectedUserRoleInToggle, setDefaultSelectedUserRoleInToggle] = useState(useBoundStore.getState().RSFSCardFilters.defaultToggleUserRole);

  const [loading, setLoading] = useState(false);
  const [note, setNote] = useState("");


  // useEffect(() => {
  //   setDefaultSelectedUserRoleInToggle(RSFSCardFilters.defaultToggleUserRole)
  // }, [RSFSCardFilters.defaultToggleUserRole]);

  //   making api call for users list
  // const getAssociations = () => {
  //   try {
  //     setLoading(true);
  //     axios
  //     .get("/api/agency_associations_appointments/" + bfile.agency_id)
  //     .then(async (res) => {
  //       let users = [];
  //       let calendar_invites = [];
  //       for (var i = 0; i < res.data.length; i++) {
  //         let user = res.data[i];

  //         if (user.id === lsp) {
  //           calendar_invites = user.calendar_invites;
  //         }

  //         if (user.user_type == "EA") {
  //           await axios.get("/api/users/" + user.id).then((res) => {
  //             users.push({
  //               name: user.first_name + " " + user.last_name,
  //               id: user.id,
  //               user_type: user.user_type,
  //               carrier: res.data.carrier,
  //               appointment_hours: user.appointment_hours,
  //               calendar_invites: user.calendar_invites,
  //               virtual_link: user.virtual_link,
  //               has_calendly: user.has_calendly,
  //               has_microsoft: user.has_microsoft,
  //               has_manual_links: user.has_manual_links,
  //               note: user.virtual_link ? user.virtual_link : "",
  //             });
  //           });
  //         }
  //         if (user.user_type == "LSP") {
  //           users.push({
  //             name: user.first_name + " " + user.last_name,
  //             id: user.id,
  //             user_type: user.user_type,
  //             appointment_hours: user.appointment_hours,
  //             calendar_invites: user.calendar_invites,
  //             virtual_link: user.virtual_link,
  //             has_calendly: user.has_calendly,
  //             has_manual_links: user.has_manual_links,
  //             has_microsoft: user.has_microsoft,
  //             note: user.virtual_link ? user.virtual_link : "",
  //           });
  //         }
  //       }

  //       setUsers(users);
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   finally{
  //     setLoading(false);
  //   }

  // };

  // useEffect(()=>{
  //   if(lsp===""){
  //     setLsp(bfile && bfile.user &&  bfile.user.id);
  //   }
  // },[lsp])

  // useEffect(() => {    
  //   if (users.length === 0) {
  //     getAssociations();
  //   }
  // }, []);

  const handleSave = () => {


    if (note.trim().length === 0) {
      // reset notification
      message.destroy();
      message.error(F.translate(`Note is required.`));
      return;
    }

    let data = null;
    let note_action = null;
    let api = null;

    /* Not Reached - Case */
    if (action === "1") {
      // update note's action
      note_action = "Not Reached";

      // if ((loggedInUser && loggedInUser.user_type === "REVIEWSCHEDULER") || defaultSelectedUserRoleInToggle === REVIEWSCHEDULER) {
      //   data = {
      //     archive: 0,
      //     rs_call_made: null,
      //     rs_action: bfile.rs_consecutive > 1 ? null : 0, // not reached  ra_action is 0 
      //     rs_attempts: bfile.rs_attempts ? bfile.rs_attempts + 1 : 1,
      //     rs_consecutive: bfile.rs_consecutive ? bfile.rs_consecutive + 1 : 1,
      //     reviewer_id: loggedInUser.id,
      //     rs_notreached_date: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      //     non_responsive: bfile.rs_consecutive > 1 ? 1 : 0,
      //     reschedule_appointment: 0,
      //     rs_date: moment(new Date())
      //       .utc()
      //       .format("YYYY-MM-DD HH:mm:ss"),
      //   };
      // } else {
      //   data = {
      //     // attempts: parseInt(bfile.attempts, 10) + 1,
      //     attempts: parseInt(bfile.attempts, 10),
      //     vob_attempted: bfile.fs_consecutive > 1 ? null : 1,  // not reached
      //     onboarder_id: loggedInUser.id,
      //     fs_consecutive: bfile.fs_consecutive ? bfile.fs_consecutive + 1 : 1,
      //     // new adding
      //     vob_archived: null,
      //     vob_completed: null,
      //     non_responsive: bfile.fs_consecutive > 1 ? 1 : 0,
      //     von_appointment_date: null,
      //     reschedule_appointment_vo: 0,
      //   };
      // }


      // axios.post("/api/ea_questions", {
      //   bfile_id: bfile.id,
      //   call_attempts: 1,
      //   was_invite_sent: false
      // });

      //today's date should not exceed expiration date
      // if (moment(new Date()).isAfter(moment(bfile.expiration_date))) {
      //   axios.post("/api/active_calls_history_details",
      //     {
      //       bfile_id: bfile.id,
      //       scheduler_specialist_id: loggedInUser.id,
      //       bfile_user_id: bfile.user_id,
      //       creator_user_id: bfile.user_id,
      //       agency_id: bfile.agency_id,
      //       rs_effective_date: bfile.rs_effective_date,
      //       expiration_date: bfile.expiration_date,
      //       type_of_call: bfile.type_of_call,
      //       sub_type_of_call: bfile.sub_type_of_call,
      //       first_name: bfile.first_name,
      //       last_name: bfile.last_name,
      //       phone: bfile.phone,
      //     }
      //   );


      // }
      //for saving call attempt history not_reached
      // saveCallAttemptHistory(bfile, 1);

      api = NOT_REACHED + "/" + bfile.id;
      data = {
        bfile_notes: {
          note: note,
          action: note_action,
          notes_type: F.getNotesType()
        }
      }
    }

    /* Not Interested - Case */
    if (action === "2") {

      // update note's action
      note_action = "Not Interested";

      api = NOT_INTERESTED + "/" + bfile.id;
      data = {
        bfile_notes: {
          note: note,
          action: note_action,
          notes_type: F.getNotesType()
        }
      }

      // if ((loggedInUser && loggedInUser.user_type === "REVIEWSCHEDULER") || defaultSelectedUserRoleInToggle == REVIEWSCHEDULER) {
      //   data = {
      //     archive: 0,
      //     rs_call_made: null,
      //     rs_action: action,
      //     rs_attempts: bfile.rs_attempts ? bfile.rs_attempts + 1 : 1,
      //     reviewer_id: loggedInUser.id,
      //     rs_consecutive: 0,
      //     rs_date: moment(new Date())
      //       .utc()
      //       .format("YYYY-MM-DD HH:mm:ss"),
      //     non_responsive: 0,
      //     reschedule_appointment: 0,
      //   };
      // } else {
      //   data = {
      //     // sp_500: 0,
      //     // vip: 0,
      //     // attempts: 0,
      //     is_onboarded: 1,
      //     onboarder_id: loggedInUser.id,
      //     expiration_date: bfile.expiration_date,
      //     archive: 0,
      //     fs_consecutive: 0,
      //     vob_archived: 1,
      //     // new adding
      //     vob_attempted: null,
      //     vob_completed: null,
      //     non_responsive: 0,
      //     von_appointment_date: null,
      //     reschedule_appointment_vo: 0,
      //   };
      // }



      // axios.post("/api/ea_questions", {
      //   bfile_id: bfile.id,
      //   call_attempts: 1,
      //   was_invite_sent: false
      // });

      //api to capture not interested history
      // axios.post("/api/not_interested_details",
      //   {
      //     bfile_id: bfile.id,
      //     bfile_user_id: bfile.user_id,
      //     creator_user_id: bfile.user_id,
      //     modifier_user_id: loggedInUser.id,
      //     agency_id: bfile.agency_id,
      //     type_of_call: bfile.type_of_call,
      //     sub_type_of_call: bfile.sub_type_of_call,
      //     first_name: bfile.first_name,
      //     last_name: bfile.last_name,
      //     phone: bfile.phone,
      //     note: note_action
      //   }
      // );

      //for saving call attempt history not_interested
      // saveCallAttemptHistory(bfile, 2);

    }

    /* Not Responsive - Case */
    if (action === "3") {

      // update note's action
      note_action = "Non Responsive";

      api = NON_RESPONSIVE + "/" + bfile.id;
      data = {
        bfile_notes: {
          note: note,
          action: note_action,
          notes_type: F.getNotesType()
        }
      }
      // if ((loggedInUser && loggedInUser.user_type === "REVIEWSCHEDULER") || defaultSelectedUserRoleInToggle == REVIEWSCHEDULER) {
      //   data = {
      //     non_responsive: 1,
      //     rs_attempts: bfile.rs_attempts ? bfile.rs_attempts + 1 : 1,
      //     rs_action: null,
      //     reviewer_id: loggedInUser.id,
      //     expiration_date: bfile.expiration_date,
      //     rs_consecutive: 0,
      //     archive: 0,
      //     reschedule_appointment: 0,
      //     rs_date: moment(new Date())
      //       .utc()
      //       .format("YYYY-MM-DD HH:mm:ss"),
      //   };
      // } else {
      //   data = {
      //     non_responsive: 1,
      //     is_onboarded: 1,
      //     onboarder_id: loggedInUser.id,
      //     expiration_date: bfile.expiration_date,
      //     archive: 0,
      //     fs_consecutive: 0,
      //     // new adding
      //     vob_archived: null,
      //     vob_attempted: null,
      //     vob_completed: null,
      //     von_appointment_date: null,
      //     reschedule_appointment_vo: 0,
      //   };
      // }


      //non_responsive
      // saveCallAttemptHistory(bfile, 3);

      // axios.post("/api/ea_questions", {
      //   bfile_id: bfile.id,
      //   call_attempts: 1,
      //   was_invite_sent: false
      // });
    }


    // if ((loggedInUser && loggedInUser.user_type !== REVIEWSCHEDULER) &&
    //   defaultSelectedUserRoleInToggle != REVIEWSCHEDULER) {
    //   axios.post("/api/ea_questions", {
    //     bfile_id: bfile.id,
    //     call_attempts: 1,
    //     was_invite_sent: false
    //   });
    // }


    /* Notes API */
    // Call Notes API
    // axios.post("/api/bfile_notes", {
    //   bfile_id: bfile.id,
    //   note: note,
    //   user_id: loggedInUser.id,
    //   action: note_action,
    //   type_of_call: bfile.type_of_call,
    //   sub_type_of_call: bfile.sub_type_of_call,

    // });



    if (data) {
      setLoading(true);
      axios.put(api, data)
        // axios.put("/api/b_file/" + bfile.id, {
        // ...data,
        // type_of_call: bfile.type_of_call,
        // sub_type_of_call: bfile.sub_type_of_call,
        // vonboard: bfile.vonboard || bfile.type_of_call && ['followup', 'prospect'].includes(bfile.type_of_call.split('-').join().toLowerCase()) ? 1 : 0,
        // review: bfile.review || bfile.type_of_call && ['Review'].includes(bfile.type_of_call.split('-').join().toLowerCase()) ? 1 : 0
        // })
        .then(() => {
          // setLoading(false);
          hideModal();
          // this.props.history.push("/bfiles/upcoming-calls");

          setTimeout(() => {
            // history.replace("/dashboard");
            // history.replace("/bfilesNew");
            props.history.goBack();

            // init()
          }, 100);

        }).finally(() => {
          setLoading(false);
        });
    }

  }

  const saveCallAttemptHistory = async (bfile, actionId) => {
    let action = '';
    if (actionId == 1) {
      action = "not_reached";
    } else if (actionId == 2) {
      action = "not_interested";
    } else if (actionId == 3) {
      action = "non_responsive";
    }

    try {
      await axios.post(CREATE_CALL_ATTEMPT_HISTORY, {
        bfile_id: bfile.id,
        scheduler_specialist_id: loggedInUser.id,
        bfile_user_id: bfile.user_id,
        agency_id: bfile.agency_id,
        type_of_call: bfile.type_of_call,
        sub_type_of_call: bfile.sub_type_of_call,
        first_name: bfile.first_name,
        last_name: bfile.last_name,
        phone: bfile.phone,
        action: action
      });
    } catch (error) {
      console.error('Error saving call attempt history:', error);
    }
  }



  return (
    <Modal
      title={<span style={{ fontWeight: "600" }}><Translate text={title} /></span>}
      visible={showModal}
      onCancel={hideModal}
      width={"600px"}
      footer={
        <React.Fragment>
          <Button onClick={hideModal}
            className="borderRadius-28"
          >
            <Translate text={`Cancel`} />
          </Button>
          <Button className="btn-bg-164897 borderRadius-28"
            loading={loading}
            onClick={handleSave}>
            <Translate text={`Save`} />
          </Button>
        </React.Fragment>
      }
    >
      <Spin indicator={antIcon} spinning={loading}>
        <div>
          {/* {users.length > 0 ? (
            <div style={{ marginBottom: 10 }}>
              <Select
                value={lsp}
                style={{ width: 300 }}
                onChange={(val) => {
                  setLsp(val);
                }}
              >
                {users.map((user, i) => (
                  <Option key={i} value={user.id}>
                    {user.name} (
                    {user.user_type === "EA"
                      ? "Agency Owner"
                      : user.user_type === "LSP"
                      ? "Agency Sales Staff"
                      : user.user_type}
                    )
                  </Option>
                ))}
              </Select>
            </div>
          ) : null} */}
          <div>
            <label>
              <Translate text={`Note`} />
              <span className="asteriskIcon">*</span>
            </label>
            <TextArea
              rows={4}
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default withRouter(AppointmentActionModal);



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/components/AppointmentActionModal.js